import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { pick, isNil, isEmpty, find } from "lodash";
import {
  AlertBox,
  Button,
  SelectInput,
  TextInput,
} from "@life-line-lab/components-react";
import { DeliveryInfoSchema } from "./delivery-info-validation";
import errorHandler from "Utils/error-handler";
import { Col, Row } from "antd";

interface DeliveryInfoComponentProps {
  onSubmit?: any;
  onPrev?: any;
  onNext?: any;
  deliveryServiceTypes?: Array<any>;
  goodCareConditionList: any;
  parentInput?: any;
  orderEditDetail?: any;
}

const initialInput = {
  deliveryType: "",
  serviceType: "",
  specialConditions: "",
  specialCare: "",
  // weight: "",
  // remarks: "",
  // length: "",
  // width: "",
  // height: "",
};
const initialError = {};

const DeliveryInfo: React.FC<DeliveryInfoComponentProps> = ({
  onPrev,
  onNext,
  deliveryServiceTypes = [],
  parentInput,
  goodCareConditionList,
  orderEditDetail,
}) => {
  const { t } = useTranslation();

  const [input, setInput] = useState<any>(initialInput);
  const [error, setError] = useState<any>(initialError);
  const [serviceTypes, setServiceTypes] = useState<any>([]);

  const { SPECIAL_CONDITION = [], SPECIAL_CARE = [] } =
    goodCareConditionList || {};

  useEffect(() => {
    if (!isEmpty(parentInput)) {
      let filteredParentInput = pick(parentInput, [
        "deliveryType",
        "serviceType",
        "specialConditions",
        "specialCare",
        "weight",
        "length",
        "width",
        "height",
      ]);
      if (filteredParentInput.deliveryType) {
        let deliveryTypeObj = find(deliveryServiceTypes, (delObj) => {
          return delObj.id == filteredParentInput.deliveryType;
        });
        setServiceTypes(deliveryTypeObj?.subOptions || []);
      }
      setInput({ ...initialInput, ...filteredParentInput });
    }
  }, [parentInput]);

  const handleFieldChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setError(initialError);
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (value: string | string[] | {}, name: string) => {
    if (name == "deliveryType") {
      let deliveryTypeObj = find(deliveryServiceTypes, (delObj) => {
        return delObj.id == value;
      });
      setServiceTypes(deliveryTypeObj.subOptions);
    }

    if (!isNil(orderEditDetail)) {
      if (name == "serviceType") {
      }
    }

    setError(initialError);
    setInput({ ...input, [name]: value });
  };

  const handleSubmit = () => {
    try {
      const valInput = {
        ...input,
        // whats the point of this
        // maxDimensions: {
        //   length: input.length,
        //   width: input.width,
        //   height: input.height,
        // },
      };

      let value: any = DeliveryInfoSchema.validateSync(valInput, {
        strict: true,
        abortEarly: true,
        stripUnknown: false,
      });

      onNext(value);
    } catch (err) {
      console.log(err);
      const { path, value }: any = errorHandler.validation(err);
      setError({
        ...error,
        [path]: t(`${value}`, { field: t(`label.${path}`) }),
      });
    }
  };

  return (
    <React.Fragment>
      {
        <div className="center header-title">
          {t("title.deliveryInfo").toUpperCase()}
        </div>
      }
      <Row gutter={[15, 15]} className="mt-50">
        <Col xs={24} sm={24} md={12} className="mb-7">
          <SelectInput
            showSearch
            options={deliveryServiceTypes.map((d) => ({
              label: d?.label,
              value: d?.id,
            }))}
            filterOption={(inputValue, option) =>
              option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
            name="deliveryType"
            placeholder={t("placeholder.deliveryType")}
            label={t("label.deliveryType")}
            value={input.deliveryType}
            isRequired={true}
            onChange={(value) => handleSelectChange(value, "deliveryType")}
          />
          <AlertBox text={error.deliveryType} />
        </Col>
        <Col xs={24} sm={24} md={12} className="mb-7">
          <SelectInput
            showSearch
            options={serviceTypes.map((s) => ({
              label: s?.label,
              value: s?.id,
            }))}
            filterOption={(inputValue, option) =>
              option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
            name="serviceType"
            placeholder={t("placeholder.serviceType")}
            label={t("label.serviceType")}
            value={input.serviceType}
            isRequired={true}
            onChange={(value) => handleSelectChange(value, "serviceType")}
          />
          <AlertBox text={error.serviceType} />
        </Col>
        <Col xs={24} sm={24} md={12} className="mb-7">
          <TextInput
            label={t("label.trackingNo")}
            placeholder={t("placeholder.trackingNo")}
            isReadonly={true}
            name="trackingNo"
            value={input.trackingNo}
            disabled
            onChange={error.trackingNo}
          />
        </Col>
        <Col xs={24} sm={24} md={12} className="mb-7">
          <SelectInput
            showSearch
            options={[{ label: "None", value: "" }].concat(
              SPECIAL_CONDITION.map((s) => ({ label: s?.name, value: s?.id })),
            )}
            filterOption={(inputValue, option) =>
              option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
            name="specialConditions"
            placeholder={t("placeholder.specialConditions")}
            label={t("label.specialConditions")}
            value={input.specialConditions}
            onChange={(value) => handleSelectChange(value, "specialConditions")}
          />
          <AlertBox text={error.specialConditions} />
        </Col>
        <Col xs={24} sm={24} md={12} className="mb-7">
          <SelectInput
            showSearch
            options={[{ label: "None", value: "" }].concat(
              SPECIAL_CARE.map((s) => ({ label: s?.name, value: s?.id })),
            )}
            filterOption={(inputValue, option) =>
              option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
            name="specialCare"
            placeholder={t("placeholder.specialCare")}
            label={t("label.specialCare")}
            value={input.specialCare}
            onChange={(value) => handleSelectChange(value, "specialCare")}
          />
          <AlertBox text={error.specialCare} />
        </Col>
      </Row>
      <div className="steps-action center mt-50">
        <Button
          onClick={() => onPrev()}
          type="ghost"
          label={t("action.back")}
          className="mr-10"
        />
        <Button
          type="primary"
          onClick={() => handleSubmit()}
          label={t("action.next")}
        />
      </div>
    </React.Fragment>
  );
};

export default DeliveryInfo;
